import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { SubscriptionBundlesVM } from '../../../viewModel/subscriptionBundles.viewModel';
import { footerWrapper, stepsWrapper } from './CreateModal.css';
import { WhatMakesSubscription } from './steps/WhatMakesSubscription';
import { AboutSubscription } from './steps/AboutSubscription';
import { Price } from '../../form/Price';

type CreateModalProps = SubscriptionBundlesVM['createBundleModal'] & {
  dispatch: SubscriptionBundlesVM['dispatch'];
};

export const CreateModal: React.FC<CreateModalProps> = ({
  isOpen,
  close,
  ...p
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    modalClassName="w-full md:w-[1120px] h-[100%] md:h-[800px]"
    contentClassName="h-[100%]"
    disableBackdropClick={true}
    footer={<Footer stepCta={p.stepCta} />}
  >
    <div className={stepsWrapper}>
      <Step {...p} />
    </div>
  </Modal>
);

const Step = ({
  step,
  ...p
}: Pick<
  CreateModalProps,
  'step' | 'control' | 'transformPrice' | 'price' | 'error' | 'dispatch'
>) => {
  switch (step) {
    case 1:
      return <AboutSubscription />;
    case 2:
      return <WhatMakesSubscription />;
    case 3:
      return <Price {...p} />;
  }
};

const Footer: React.FC<Pick<CreateModalProps, 'stepCta'>> = ({ stepCta }) => (
  <div className={footerWrapper}>
    {stepCta.map(({ title, onClick, variant, submitting }) => (
      <Button
        key={title}
        color="neutral"
        onClick={onClick}
        variant={variant || 'filled'}
        disabled={submitting}
        loading={submitting}
      >
        {title}
      </Button>
    ))}
  </div>
);
